import * as React from 'react';

import type { EmbeddedContentProps } from './EmbeddedContent';
import OembeddedContent from './OembeddedContent';

const apiUrl = 'https://soundcloud.com/oembed';

export const EmbeddedSoundCloud: React.FC<EmbeddedContentProps> = (props) => {
  return <OembeddedContent apiUrl={apiUrl} {...props} />;
};

export const isEmbeddedSoundCloud = (url: string) => {
  const regexes = [/https?:\/\/soundcloud.com\/.*/];

  if (regexes.some((regex) => url.match(regex))) {
    return true;
  }

  return false;
};

export default EmbeddedSoundCloud;
